import React from "react";
import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";

export const InstitutionalFooter = ({ settings, brands = [] }) => {
  const year = new Date().getFullYear();
  const linkedin = settings?.social?.linkedin;
  const visibleBrands = brands.filter((b) => b.isVisible !== false).slice(0, 6);
  const leadershipEnabled = !!settings?.leadershipEnabled;

  const quickLinks = [
    ["/about", "About"],
    ["/companies", "Companies"],
    ...(leadershipEnabled ? [["/leadership", "Leadership"]] : []),
    ["/governance", "Governance"],
    ["/careers", "Careers"],
    ["/news", "News"],
    ["/contact", "Contact"],
  ];

  const linkStyle = { color: "var(--muted)" };
  const hover = (e) => (e.currentTarget.style.color = "var(--text)");
  const unhover = (e) => (e.currentTarget.style.color = "var(--muted)");

  return (
    <footer data-testid="site-footer" className="surface-dark border-t" style={{ borderColor: "var(--card-border)" }}>
      <div className="container-inst py-12">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <img src="/brand/logo-full.webp" alt="Acharya Holdings" className="w-auto" style={{ height: "5rem", opacity: 0.95 }} />
            <p className="mt-4 max-w-xs text-sm leading-relaxed" style={{ color: "var(--muted)" }}>
              An independent venture house building and stewarding long-term businesses for generations.
            </p>
          </div>

          <div>
            <p className="motif-caps">Companies</p>
            <ul className="mt-4 space-y-2.5">
              {visibleBrands.map((b) => (
                <li key={b.id}>
                  {b.website && !b.comingSoon ? (
                    <a href={b.website} target="_blank" rel="noopener noreferrer" className="text-sm transition-colors" style={linkStyle} onMouseEnter={hover} onMouseLeave={unhover}>{b.name}</a>
                  ) : (
                    <span className="text-sm" style={{ color: "var(--fg-subtle)" }}>{b.name}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="motif-caps">Quick Links</p>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map(([to, label]) => (
                <li key={to}><Link to={to} className="text-sm transition-colors" style={linkStyle} onMouseEnter={hover} onMouseLeave={unhover}>{label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <p className="motif-caps">Contact</p>
            <address className="mt-4 space-y-1 text-sm not-italic" style={{ color: "var(--muted)" }}>
              {settings?.address?.line1 && <p>{settings.address.line1}</p>}
              {settings?.address?.line2 && <p>{settings.address.line2}</p>}
              {settings?.address?.line3 && <p>{settings.address.line3}</p>}
              {settings?.address?.line4 && <p>{settings.address.line4}</p>}
            </address>
            <div className="mt-4 space-y-1 text-sm" style={{ color: "var(--muted)" }}>
              {(settings?.phones || []).map((p) => (
                <p key={p}><a href={`tel:${p.replace(/\s/g,"")}`} style={linkStyle} onMouseEnter={hover} onMouseLeave={unhover} className="transition-colors">{p}</a></p>
              ))}
            </div>
            {linkedin && (
              <a href={linkedin} target="_blank" rel="noopener noreferrer" data-testid="footer-social-link"
                aria-label="LinkedIn" className="mt-4 inline-flex h-9 w-9 items-center justify-center rounded-full border transition-colors"
                style={{ borderColor: "var(--card-border)", color: "var(--muted)" }}
                onMouseEnter={(e) => { e.currentTarget.style.color = "var(--text)"; e.currentTarget.style.borderColor = "var(--accent)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = "var(--muted)"; e.currentTarget.style.borderColor = "var(--card-border)"; }}>
                <Linkedin size={16} />
              </a>
            )}
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t pt-6 sm:flex-row" style={{ borderColor: "var(--card-border)" }}>
          <p className="text-xs" style={{ color: "var(--fg-subtle)" }}>Acharya Holdings • © {year}</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-xs transition-colors" style={linkStyle} onMouseEnter={hover} onMouseLeave={unhover}>Privacy</Link>
            <Link to="/terms" className="text-xs transition-colors" style={linkStyle} onMouseEnter={hover} onMouseLeave={unhover}>Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
